<!-- <div class="content-wrapper container-xxl p-0"> -->
<div class="content-wrapper">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <section id="sample-page">
            <div class="row">
                <div id="stepper1" class="bs-stepper horizontal-wizard-example"></div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-body pb-1">
                            <form #cadastroForm="ngForm">
                                <div class="card-body pb-1">
                                    <div *ngIf="!isUploaded">
                                        <div class="row">
                                            <div class="col-md-6 col-12">
                                                <div class="form-group mb-2">
                                                    <label>Selecione um arquivo XLS/CSV:</label>
                                                    <div class="form-group" *ngIf="!resultado_show">
                                                        <div class="custom-file">
                                                            <input [disabled]="spinnerImportar" class="custom-file-input"
                                                                #file id="file" type="file"
                                                                (change)="handleFileInput($event)">
                                                            <label class="custom-file-label" #labelImport
                                                                for="fileToUpload">{{fileToUpload != null ?
                                                                fileToUpload.name : "Nenhum arquivo selecionado"}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-6 col-12">
                                                <div class="form-group mb-2">
                                                    <label for="basicSelect">Broker:</label>
                                                    <select name="id_broker" class="form-control" id="basicSelect" required
                                                        [(ngModel)]="id_selected_broker" (change)="verifyAlreadyImported()">
                                                        <option [value]="0">
                                                            Selecione um Broker
                                                        </option>
                                                        <option [value]="item.id_broker" *ngFor="let item of brokers">
                                                            {{item.broker}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <span *ngIf="isImported" style="color: red">Este broker já foi importado!<br><br></span>

                                        <button class="btn btn-primary mt-1"
                                            [disabled]="fileToUpload == null || spinnerImportar || separador == '' || isImported"
                                            (click)="importarCsv(fileToUpload)">
                                            <span *ngIf="spinnerImportar"
                                                class="spinner-border spinner-border-sm mr-1"></span>
                                            <span>Importar</span>
                                        </button>
                                        <br><br>
                                        <span *ngIf="spinnerImportar">Processando dados. Aguarde um instante...</span>

                                        <hr>
                                    </div>
                                    <div *ngIf="dadosImportados.length == 0">
                                        <h3>Nenhum dado importado.</h3>
                                    </div>
                                    <h2>Fechamento Finalizado</h2>
                                    <div *ngIf="dadosImportados.length != 0">
                                        <h3>Dados importados:</h3>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Broker</th>
                                                    <th>Quantidade</th>
                                                    <th *ngIf="!isUploaded">Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let dado of dadosImportados">
                                                    <td>{{ dado.broker }}</td>
                                                    <td>{{ dado.qtd }}</td>
                                                    <td *ngIf="!isUploaded"><button class="btn btn-primary" (click)="excluirDadosImportados(dado.id_broker)">Excluir</button></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                    <button  class="btn btn-primary mt-1" *ngIf="dadosImportados.length != 0 && !isUploaded"
                                        (click)="finalizarImportacao()">
                                        <span *ngIf="spinnerFinalizacao"
                                            class="spinner-border spinner-border-sm mr-1"></span>
                                        <span>Finalizar Importação</span>
                                    </button>

                                    <a class="btn btn-outline-primary mt-1 ml-1" *ngIf="dadosImportados.length != 0"
                                        routerLink="/fechamento/{{id_fechamento}}/chips-importados">Ver Chips Importados</a>


                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>